import type { Device } from "types/device.types"
import type { QueryPlotDef } from "types/dashboard.types"

import {
  wStationAmbientTabPlotDefs,
  wServiceAmbientTabPlotDefs,
} from "helpers/config/dashboards"

export interface DeviceAmbientConfig {
  type: "wStationAmbientTab" | "wServiceAmbientTab"
  plotDefs: QueryPlotDef[]
}

/**
 * Single source of truth for the ambient (weather) tab a device page renders.
 * A device shows at most one ambient tab: weather-station telemetry for
 * tower-installed devices with the weather feature enabled, or weather-service
 * (geohash) data for span devices that have a geolocation. Returns null when no
 * ambient tab is shown.
 */
export const getDeviceAmbientConfig = (
  device: Device | undefined,
): DeviceAmbientConfig | null => {
  if (!device) return null

  const isDeviceOnTowerAmbient =
    device.settings?.installation_type === "tower" &&
    !!device.settings?.features?.weather?.was_enabled

  const isDeviceOnSpanAmbient =
    device.device_type === "sentrisense" &&
    device.settings?.installation_type === "powerline" &&
    !!device.settings?.geo_location?.latitude &&
    !!device.settings?.geo_location?.longitude

  if (isDeviceOnTowerAmbient)
    return { type: "wStationAmbientTab", plotDefs: wStationAmbientTabPlotDefs }
  if (isDeviceOnSpanAmbient)
    return { type: "wServiceAmbientTab", plotDefs: wServiceAmbientTabPlotDefs }

  return null
}
